import { _ as k } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.object.assign-7e79fd7b.js";
import { QUERIES as j } from "@ucl/shared-component-foundations";
import { c as n } from "./index-8b07dec9.js";
import * as M from "react";
import { createContext as P, useContext as $, createElement as w } from "react";
import h, { css as f } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as g } from "./cloneSlots-622cf8c9.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as T } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import { useMediaQuery as O } from "./useMediaQuery.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as L } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { a as E } from "./index-5d0f31c6.js";
import "./es.string.link-fd2676c6.js";
import { Link as N } from "./link.js";
import { jsx as a, jsxs as S } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./es.array.is-array-7a29277f.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./isApiSupported-66660265.js";
import "./isClient-2f5bedbd.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./useIsMounted.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./string-html-forced-a746405b.js";
import "./es.string.starts-with-a6645e0a.js";
import "./aria.js";
var x = /* @__PURE__ */ P({
  size: "small"
}), Q = ["children", "isCurrentPage", "dataTestId", "lastItem"], R = /* @__PURE__ */ h.li.withConfig({
  displayName: "breadcrumbItem__StyledBreadcrumbItem",
  componentId: "sc-11koegt-0"
})(["&.Breadcrumb__list-item{", ";}"], function(m) {
  var r = m.theme, c = r.components.breadcrumb, l = r.componentStyles;
  return f(c.BreadcrumbItem, l);
}), q = /* @__PURE__ */ h.span.withConfig({
  displayName: "breadcrumbItem__Separator",
  componentId: "sc-11koegt-1"
})(["&.Breadcrumb__list-separator{", ";}"], function(m) {
  var r = m.theme.components.breadcrumb;
  return f(r.Separator);
}), z = function(r) {
  var c = r.children, l = r.isCurrentPage, d = r.dataTestId, u = r.lastItem, b = k(r, Q), _ = $(x), p = _.size, t = p === void 0 ? "small" : p, I = L(c, {
    link: N
  }), B = g(I.link, function(s, o) {
    var e;
    return u ? /* @__PURE__ */ a("span", {
      children: s.children
    }) : /* @__PURE__ */ w(N, Object.assign({}, s, {
      key: o,
      isCurrentPage: (e = s.isCurrentPage) != null ? e : l,
      className: n(["Breadcrumb__list-item__link", "Breadcrumb__list-item__link--" + t, s.className]),
      size: t
    }));
  });
  return /* @__PURE__ */ S(R, Object.assign({
    "data-testid": d
  }, b, {
    className: n(["Breadcrumb__list-item", b.className]),
    children: [B, /* @__PURE__ */ a(q, {
      className: n(["Breadcrumb__list-separator", "Breadcrumb__list-separator--" + t]),
      children: "/"
    })]
  }));
};
z.Link = N;
var U = ["children", "size", "firstChildLink", "dataTestId"], y = /* @__PURE__ */ h.ul.withConfig({
  displayName: "breadcrumb__BreadcrumbList",
  componentId: "sc-1iy9kyw-0"
})(["&.Breadcrumb__list{", ";}"], function(m) {
  var r = m.theme.components.breadcrumb;
  return f(r.BreadcrumbList);
}), V = /* @__PURE__ */ h.a.withConfig({
  displayName: "breadcrumb__MobileCaretLeftIcon",
  componentId: "sc-1iy9kyw-1"
})(["&.Breadcrumb__list-caret-icon--left{", ";}"], function(m) {
  var r = m.theme.components.breadcrumb;
  return f(r.MobileCaretLeftIcon);
}), v = function(r) {
  var c, l = r.children, d = r.size, u = d === void 0 ? "small" : d, b = r.firstChildLink, _ = r.dataTestId, p = k(r, U), t = L(l, {
    items: v.Item
  }), I = T({
    label: "BreadCrumbs"
  }), B = O(j.mobile), s = t.items.findIndex(function(e) {
    var i = e == null ? void 0 : e.props;
    return (i == null ? void 0 : i.isCurrentPage) !== void 0 ? i.isCurrentPage : !1;
  }), o = s > 0 ? t.items[s - 1] : t.items[0];
  return /* @__PURE__ */ a(x.Provider, {
    value: {
      size: u
    },
    children: /* @__PURE__ */ a("nav", Object.assign({
      "aria-label": "breadcrumbs"
    }, I, p, {
      className: n(["Breadcrumb", p.className]),
      children: B ? /* @__PURE__ */ S(y, {
        "data-testid": _,
        className: "Breadcrumb__list",
        children: [/* @__PURE__ */ a(V, {
          className: "Breadcrumb__list-caret-icon--left",
          href: /* @__PURE__ */ M.isValidElement(o == null ? void 0 : o.props.children) ? o == null || (c = o.props.children.props) == null ? void 0 : c.to : b,
          "aria-label": "mobile-chevron",
          children: /* @__PURE__ */ a(E, {
            icon: "caretLeft",
            size: "m"
          })
        }), o && g(o, function(e, i) {
          return /* @__PURE__ */ a(v.Item, Object.assign({}, e, {
            className: n([e.className, "Breadcrumb__list-item--last"])
          }), i);
        })]
      }) : /* @__PURE__ */ a(y, {
        "data-testid": _,
        className: "Breadcrumb__list",
        children: g(t.items, function(e, i) {
          var C;
          return /* @__PURE__ */ a(v.Item, Object.assign({}, e, {
            lastItem: i === t.items.length - 1,
            className: n([e.className, {
              "Breadcrumb__list-item--last": i === t.items.length - 1
            }, (C = {}, C["Breadcrumb__list-item--last--" + u] = i === t.items.length - 1, C)])
          }), i);
        })
      })
    }))
  });
};
v.Item = z;
export {
  v as Breadcrumb
};
